var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Button, Dialog, Grid } from 'pcln-design-system';
import { ArrowLeft } from 'pcln-icons';
import styled from 'styled-components';
var FlexButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n  }\n\n  &:focus-visible {\n    box-shadow: none;\n  }\n"], ["\n  &&& {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n  }\n\n  &:focus-visible {\n    box-shadow: none;\n  }\n"
    /** @public */
])));
/** @public */
var InputModal = function (_a) {
    var children = _a.children, footer = _a.footer, id = _a.id, input = _a.input, inputProps = _a.inputProps, isOpen = _a.isOpen, subheading = _a.subheading, zIndex = _a.zIndex, onClose = _a.onClose;
    function handleClose() {
        onClose(false);
    }
    return (React.createElement(Dialog, { ariaDescription: id, ariaTitle: "Input Modal - ".concat(id), footerContent: footer, headerContent: React.createElement(React.Fragment, null,
            React.createElement(Grid, { "data-testid": 'input-header', alignItems: inputProps === null || inputProps === void 0 ? void 0 : inputProps.alignItems, templateColumns: 'auto 1fr', templateRows: '1fr auto', width: 1 },
                React.createElement(FlexButton, { "aria-label": 'Close', borderRadius: 'full', boxShadowSize: 'sm', height: '40px', width: '40px', mr: '12px', size: 'large', variation: 'white', onClick: handleClose },
                    React.createElement(ArrowLeft, { color: 'primary' })),
                React.cloneElement(input, { autoFocus: true, width: 1 })),
            subheading), headerContentProps: __assign({ templateColumns: '1fr' }, inputProps), innerContentOverflow: 'hidden', open: isOpen, showCloseButton: false, showScrollShadow: true, sheet: true, size: 'full', zIndex: zIndex, onOpenChange: onClose }, children));
};
export default InputModal;
var templateObject_1;
//# sourceMappingURL=InputModal.js.map